import {BaseContainerModel} from '../base-container.model';
import {bl_fi_generic_doc_file_export_RowClass} from '../../dbschema';

export class GenericDocFileExportContainerModel extends BaseContainerModel {
    bl_fi_generic_doc_file_export: bl_fi_generic_doc_file_export_RowClass = new bl_fi_generic_doc_file_export_RowClass();
}
 